<template>
  <div>
    <b-row class="no-gutters my-3">
      <b-col lg="6">
        <b-input-group class="panel-input-serach">
          <b-form-input
            class="input-serach"
            placeholder="search name"
            @keyup="handleSearch"
            v-model="filter.postName"
          ></b-form-input>
          <b-input-group-prepend>
            <span class="icon-input m-auto pr-2">
              <font-awesome-icon icon="search" />
            </span>
          </b-input-group-prepend>
        </b-input-group>
      </b-col>
      <b-col lg="6" class="text-center text-sm-right"
        ><router-link :to="`/live/create/${postTypeId}/0`">
          <b-button class="btn-main">
            <div>
              <font-awesome-icon icon="user-plus" />
              <span class="ml-2">CREATE NEW</span>
            </div>
          </b-button>
        </router-link></b-col
      >
    </b-row>
    <b-row class="main-theme no-gutters px-3 px-sm-0 ">
      <b-col>
        <b-table
          class="table-list"
          striped
          responsive
          hover
          :items="items"
          :fields="fields"
          :busy="isBusy"
          show-empty
          empty-text="ไม่พบข้อมูล"
        >
          <template v-slot:table-busy>
            <div class="text-center text-black my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="ml-2">Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(nameAndTags)="data">
            <div class="d-flex justify-content-center">
              {{ data.item.name }}
            </div>
            <div class="d-flex justify-content-center">
              <span
                class="word"
                v-for="(item, index) in data.item.keyword"
                :key="index"
                >{{ item }}</span
              >
            </div>
          </template>

          <template v-slot:cell(postTypeId)="data">
            <div class="d-flex justify-content-center">
              {{ data.item.postTypeId == 1 ? "Live" : "" }}
              {{ data.item.postTypeId == 2 ? "Post" : "" }}
            </div>
          </template>
          <template v-slot:cell(createdTime)="data">
            <div class="d-flex justify-content-center">
              {{ new Date(data.item.createdTime) | moment($formatDate) }} 
              <br />
              ({{ new Date(data.item.createdTime) | moment($formatTime) }})
            </div>
          </template>
          <template v-slot:cell(postCreatedTime)="data">
            <div class="d-flex justify-content-center">
              {{ new Date(data.item.postCreatedTime) | moment($formatDate) }} 
              <br />
              ({{ new Date(data.item.postCreatedTime) | moment($formatTime) }})
            </div>
          </template>
          <template v-slot:cell(updatedTime)="data">
            <div class="d-flex justify-content-center">
              {{ new Date(data.item.updatedTime) | moment($formatDate) }} 
              <br />
              ({{ new Date(data.item.updatedTime) | moment($formatTime) }})
            </div>
          </template>
          <template v-slot:cell(id)="data">
            <div class="d-flex justify-content-center">
              <router-link :to="'/live/detail/' + data.item.id">
                <b-button variant="link" class="text-warning px-1 py-0">
                  <!-- <font-awesome-icon
                    icon="pencil-alt"
                    class="text-primary"
                    title="View"
                  /> -->
                  Live Detail
                </b-button>
              </router-link>
              <!-- <router-link :to="'/live/edit/' + data.item.id"> -->
              <router-link :to="`/live/edit/${postTypeId}/${data.item.id}`">
                <b-button variant="link" class="text-warning px-1 py-0">
                  <font-awesome-icon
                    icon="pencil-alt"
                    class="text-primary"
                    title="View"
                  />Edit
                </b-button>
              </router-link>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-pagination
      v-model="filter.paging.pageNo"
      :total-rows="rows"
      :per-page="filter.paging.perPage"
      class="m-md-0"
      @change="pagination"
      align="right"
    ></b-pagination>
  </div>
</template>

<script>
export default {
  props: {
    pageId: {
      type: String,
      required: true,
    },
    postTypeId: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      fields: [
        {
          key: "createdTime",
          label: "Date / Time Create",
          class: "w-180px",
        },
        {
          key: "postTypeId",
          label: "Type",
          class: "w-100px",
        },
        {
          key: "nameAndTags",
          label: "Live name / Tags",
          class: "w-160px",
        },
        {
          key: "postCreatedTime",
          label: "Publish date",
          class: "w-100px",
        },
        {
          key: "likeCount",
          label: "Like",
          class: "w-100px",
        },
        {
          key: "commentCount",
          label: "Comment",
          class: "w-100px",
        },
        {
          key: "orderCount",
          label: "Confirm",
          class: "w-100px",
        },
        {
          key: "updatedTime",
          label: "Last Update",
          class: "w-100px",
        },
        {
          key: "statusName",
          label: "Status",
          class: "w-100px",
        },
        {
          key: "id",
          label: "Action",
        },
      ],
      filter: {
        postName: "",
        postTypeId: null,
        pageId: null,
        paging: {
          pageNo: 1,
          perPage: 10,
        },
      },
      items: [],
      rows: 0,
      startPage: 1,
      endPage: 0,
    };
  },
  created() {
    this.filter.pageId = this.pageId;
    this.filter.postTypeId = this.postTypeId;
    this.getList();
  },
  methods: {
    pagination(Page) {
      this.filter.paging.pageNo = Page;
      this.getList();
    },
    handleSearch(e) {
      if (e.keyCode === 13) {
        this.filter.paging.pageNo = 1;
        this.getList();
      }
    },
    async getList() {
      this.isBusy = true;
      await this.axios
        .post(`${this.$baseUrl}/livePost/list`, this.filter)
        .then((data) => {
          this.isBusy = false;
          console.log("get list", data);
          if (data.result == 1) {
            this.items = data.detail.dataList;
            this.rows = data.detail.count;
          }
        });
    },
  },
};
</script>

<style></style>
